export const SET_FEATURED_EVENT_DATA = 'SET_FEATURED_EVENT_DATA'
